module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redundant"
  }, [(_vm.item.attr === 'address') ? _c('v-address', {
    attrs: {
      "attrValue": _vm.form.address
    },
    on: {
      "change": _vm.addressSave
    }
  }) : (_vm.item.attr === 'phone') ? _c('v-phone', {
    attrs: {
      "attrValue": _vm.form.phone
    },
    on: {
      "numChange": _vm.phoneSave,
      "update:attrValue": function($event) {
        _vm.$set(_vm.form, "phone", $event)
      }
    }
  }) : (_vm.item.attr === 'managerId') ? [_c('v-manager', {
    attrs: {
      "item": _vm.item,
      "form": _vm.form
    }
  })] : (_vm.item.attr === 'productList') ? [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "v-area"
  }, [(_vm.form[_vm.item.attr] && _vm.form[_vm.item.attr].length) ? [_vm._v(_vm._s(_vm._f("productLen")(_vm.form[_vm.item.attr])))] : [_vm._v("暂无关联产品")]], 2), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": _vm.emitParent
    }
  }, [_vm._v("选择")])])] : _c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560b1883","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/supplier/index.vue
// module id = 1276
// module chunks = 82